import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["isDisabledTime"];
import { useDisabled as useDisabledBase } from '../datepicker/useDisabled';
export function useDisabled(formats) {
  var _useDisabledBase = useDisabledBase(formats),
    isDisabledTime = _useDisabledBase.isDisabledTime,
    rest = _objectWithoutPropertiesLoose(_useDisabledBase, _excluded);
  function isDisabledTimeByStep(value, flag) {
    return isDisabledTime(formats.createDateByValueFormat(value), flag);
  }
  return _extends({
    isDisabledTime: isDisabledTime,
    isDisabledTimeByStep: isDisabledTimeByStep
  }, rest);
}